module.exports = __webpack_public_path__ + "media/images/ic-avatar-barra-a1d403e380c09af23b81f12aa9eafa3f.svg";